import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '@components/svg.component';
import { HistoryService } from '@services/history.service';
import { OrderStatusFilter } from '@models/order/order.model';

interface FilterConfig {
  value: OrderStatusFilter;
  labelKey: string;
  bg: string;
  fg: string;
  border: string;
}

export const ORDER_LIST_FILTERS: FilterConfig[] = [
  {
    value: 'all',
    labelKey: 'common.all',
    bg: 'bg-bleu-1',
    fg: 'fg-bleu-1',
    border: 'border-bleu-1',
  },
  {
    value: 'valid',
    labelKey: 'order_list.filter.valid',
    bg: 'bg-vert-1',
    fg: 'fg-vert-1',
    border: 'border-vert-1',
  },
  {
    value: 'waiting',
    labelKey: 'order_list.filter.waiting',
    bg: 'bg-orange-1',
    fg: 'fg-orange-1',
    border: 'border-orange-1',
  },
  {
    value: 'forced',
    labelKey: 'order_list.filter.forced',
    bg: 'bg-rose-1',
    fg: 'fg-rose-1',
    border: 'border-rose-1',
  },
];

@Component({
  selector: 'app-order-list-header',
  templateUrl: './order-list-header.component.html',
  imports: [TranslateModule, SvgComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class:
      'shrink-0 h-[88px] border-t border-b border-gris-3 grid grid-cols-[1fr_auto_1fr] px-5 items-center',
  },
})
export class OrderListHeaderComponent {
  private readonly router = inject(Router);
  private readonly historyService = inject(HistoryService);

  readonly activeFilter = input<OrderStatusFilter>('all');
  readonly counts = input<Partial<Record<OrderStatusFilter, number>>>({});
  readonly totalCollectedFormatted = input('');
  readonly searchQuery = input('');

  readonly filterChange = output<OrderStatusFilter>();
  readonly searchChange = output<string>();

  protected readonly filters = ORDER_LIST_FILTERS;

  goBack(): void {
    this.historyService.back();
  }
}
